/* Minuteur du panier coulissant, mode "Réservation après ajout au panier" (v5, 28/10/2026).
   Chargé seulement si ce mode est choisi (section R2 Pied de page).
   A N'ACTIVER QUE SI LE WMS BLOQUE VRAIMENT LA PAIRE pendant la durée réglée.
   Chaque paire ajoutée a son propre délai, compté depuis son ajout au panier.
   r2.js affiche le panier normalement, ce script ajoute le bandeau au-dessus. */
(function () {
  var R = window.R2 = window.R2 || {}, T = R.timer || {};
  if (!T.hold) return;
  var DUR = Math.max(1, +T.min || 15) * 60000, KEY = 'r2hold';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var p2 = function (n) { return (n < 10 ? '0' : '') + n; };

  function load() { try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { return {}; } }
  function save(m) { try { localStorage.setItem(KEY, JSON.stringify(m)); } catch (e) {} }

  // 1. On note l'heure d'ajout de chaque paire (ajout AJAX sur cart/add.js)
  var f0 = window.fetch;
  if (f0) window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = f0.apply(window, arguments);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
      p.then(function (res) {
        if (!res.ok) return;
        res.clone().json().then(function (d) {
          var m = load(), now = Date.now();
          (d.items || [d]).forEach(function (i) {
            if (!i || !i.variant_id) return;
            m[i.variant_id] = now;
            // Point de branchement WMS : la réservation réelle doit partir d'ici (ou du backend)
            try { document.dispatchEvent(new CustomEvent('r2:hold', { detail: { variant_id: i.variant_id, until: now + DUR } })); } catch (e) {}
          });
          save(m);
        }).catch(function () {});
      }).catch(function () {});
    }
    return p;
  };

  // 2. Paires présentes dans le panier affiché (clé de ligne = "id_variante:hash")
  function cartVariants() {
    var out = [];
    document.querySelectorAll('#r2CartBody [data-r2-rm]').forEach(function (b) {
      var v = String(b.getAttribute('data-r2-rm') || '').split(':')[0];
      if (v) out.push(v);
    });
    return out;
  }
  // Fin de la réservation la plus proche, ou 0 si aucune réservation en cours
  var allHeld = false;
  function holdEnd() {
    var vs = cartVariants(), m = load(), n = {}, end = 0, now = Date.now();
    allHeld = vs.length > 0;
    vs.forEach(function (v) {
      if (!m[v]) { allHeld = false; return; }
      n[v] = m[v];
      var e = m[v] + DUR;
      if (e > now) { if (!end || e < end) end = e; } else allHeld = false;
    });
    save(n); // on oublie les paires retirées du panier
    return end;
  }

  var end = 0;
  function hhmm(t) { var d = new Date(t); return d.getHours() + 'h' + p2(d.getMinutes()); }
  function paint() {
    var body = $('#r2CartBody'); if (!body) return;
    end = holdEnd();
    var el = $('[data-r2-hold]', body);
    if (!end) { if (el) el.remove(); return; }
    if (!el) {
      el = document.createElement('div');
      el.className = 'cart-timer';
      el.style.marginBottom = '12px';
      el.setAttribute('data-r2-hold', '');
      el.innerHTML = '<span class="ct-dot"></span><span data-ct-txt></span><i class="ct-bar" data-ct-bar></i>';
      body.insertBefore(el, body.firstChild);
    }
    // Le bandeau "pas réservée" devient vrai : réservée jusqu'à telle heure
    var u = $('#r2CartFoot .uniq-cart span:last-child');
    if (u && allHeld) {
      var many = cartVariants().length > 1;
      u.textContent = (many ? 'Réservées pour toi jusqu\'à ' : 'Réservée pour toi jusqu\'à ') + hhmm(end) + (many ? '. Passé ce délai, elles repartent en vente.' : '. Passé ce délai, elle repart en vente.');
    }
    tick();
  }
  function tick() {
    var el = $('[data-r2-hold]'); if (!el || !end) return;
    var ms = Math.max(0, end - Date.now());
    if (!ms) { end = 0; if (R.renderCart) R.renderCart(); else el.remove(); return; }
    var s = Math.floor(ms / 1000), t = p2(Math.floor(s / 60)) + ':' + p2(s % 60);
    var tx = $('[data-ct-txt]', el);
    if (tx) tx.innerHTML = String(T.htext || 'Ta paire est réservée encore {timer}').replace('{timer}', '<b>' + t + '</b>');
    var bar = $('[data-ct-bar]', el);
    if (bar) bar.style.width = Math.min(100, ms / DUR * 100) + '%';
  }

  // 3. A chaque rendu du panier par r2.js, on (re)pose le bandeau
  function watch() {
    var body = $('#r2CartBody'), foot = $('#r2CartFoot');
    if (!body || !window.MutationObserver) return;
    var busy = false;
    var mo = new MutationObserver(function () { if (busy) return; busy = true; paint(); busy = false; });
    mo.observe(body, { childList: true });
    if (foot) mo.observe(foot, { childList: true });
    paint();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  setInterval(function () { if ($('#r2Cart.show')) tick(); }, 1000);
})();
